import overArg from './_overArg.js';

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

export default getPrototype;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_getPrototype.js
// module id = 1580
// module chunks = 7